// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");

function EmailInput(props) {
  var __readOnly = props.readOnly;
  var __emailLabelClassName = props.emailLabelClassName;
  var __emailInputClassName = props.emailInputClassName;
  var emailInputClassName = __emailInputClassName !== undefined ? __emailInputClassName : "border border-gray-500 hover:border-gray-700 focus:border-teal-500 outline-none w-400-px px-20-px py-10-px";
  var emailLabelClassName = __emailLabelClassName !== undefined ? __emailLabelClassName : "mb-10-px font-semibold";
  var readOnly = __readOnly !== undefined ? __readOnly : false;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("label", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: props.label,
                              className: emailLabelClassName
                            }),
                        JsxRuntime.jsx("input", {
                              className: emailInputClassName,
                              readOnly: readOnly,
                              type: "email",
                              value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, props.email),
                              onChange: props.handleChange
                            })
                      ],
                      className: "block mb-10-px"
                    }),
                JsxRuntime.jsx("div", {
                      children: props.errorText,
                      className: props.errorCSS
                    })
              ]
            });
}

var make = EmailInput;

exports.make = make;
/* react/jsx-runtime Not a pure module */
